import { mapGetters, mapMutations, mapActions } from 'vuex';
//import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
export default {
    name: 'homePhotos',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    methods: {
        goToSavedSearch: function () {
            if (this.glb && this.glb.user && this.glb.user.id) {
                window.location.href = this.glb.appUrl + 'my-movoto/saved-searches/';
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin', redirectUrl: this.glb.appUrl + 'my-movoto/saved-searches/' }, trigger: this.$options.name });
            }
        },
    },
};
